module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/filter-7374cd99691fdaf89e8d94f00934c612.svg";